import { useState, useRef, useCallback } from "react";
import "./SchoolWork.scss";
import WorkCard from "./WorkCard";
import { SectionLoader } from "../../Loader/sectionLoader";
import NoDataScreen from "../../EmptyScreen/EmptyScreen";

const SchoolWork = ({
  title,
  feedData,
  loading,
  fetchMoreFeed,
  showGrade=false,
}: {
  title: string;
  feedData?: any;
  loading?: boolean;
  fetchMoreFeed?: () => void;
  showGrade?: boolean;
}) => {
  console.log(feedData, "feedDatafeedDatafeedDatafeedData");

  // prevent duplicate requests while a page is loading
  const isFetchingRef = useRef(false);
  // debounce timer
  const timerRef = useRef<number | null>(null);

  const handleScroll = useCallback(
    (e: any) => {
      // Use currentTarget so we get the scrolling container, not inner element
      const target = e.currentTarget as HTMLElement;
      if (!target) return;

      const { scrollTop, scrollHeight, clientHeight } = target;

      // debounce rapid scroll events
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }

      timerRef.current = window.setTimeout(() => {
        const nearBottom = scrollHeight - scrollTop <= clientHeight + 50;

        // stop if not near bottom, or already fetching, or parent says loading
        if (!nearBottom) return;
        if (isFetchingRef.current) return;
        if (loading) return;

        // prevent further calls until this one finishes
        isFetchingRef.current = true;

        // call user-provided fetchMoreFeed; support sync or async
        try {
          const maybePromise = fetchMoreFeed?.();
          if (
            maybePromise &&
            typeof (maybePromise as any).then === "function"
          ) {
            (maybePromise as Promise<any>)
              .catch((err) => console.error(err))
              .finally(() => {
                isFetchingRef.current = false;
              });
          } else {
            // no promise returned; release lock immediately
            isFetchingRef.current = false;
          }
        } catch (err) {
          console.error(err);
          isFetchingRef.current = false;
        }
      }, 120);
    },
    [fetchMoreFeed, loading],
  );

  return (
    <section className="school-work">
      <header className="school-work__header">
        <h2>{title}</h2>
      </header>

      <div
        className="school-work__list"
        onScroll={handleScroll}
        style={{
          maxHeight: "700px",
          overflowY: "auto",
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE/Edge
        }}
      >
        {/* Hide scrollbar for Chrome, Safari and Opera */}
        <style>
          {`
            .school-work__list::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>
        {feedData?.allData?.length === 0 && <NoDataScreen />}

        {feedData?.allData?.map((item: any) => (
          <WorkCard key={item.id} item={item} showGrade={showGrade} />
        ))}

        {loading && <SectionLoader />}
      </div>
    </section>
  );
};

export default SchoolWork;
